import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { ProductCardData } from '../../product-card/product-card-display';
import { connect } from 'pwa-helpers';
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';

@customElement('mhecomm-print-catalog-card-view')
export class PrintCatalogCardView extends connect(store)(BaseComponent) {
  /**
   * A product card data array.
   */
  @property({type: Array})
  products?: Array<ProductCardData>;

  @property({ type: Boolean })
  showProductWishList?: boolean = true;

  renderComp() {
    return html`
      <mhecomm-product-program-card-view 
        .products="${this.products}"
        ?showProductWishList=${this.showProductWishList}
      >
      </mhecomm-product-program-card-view>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-print-catalog-card-view': PrintCatalogCardView;
  }
}
